export class Math2{
	
	
	static getProgressionValue(_input, _minsrc, _maxsrc, _mindst, _maxdst)
	{
		var _percentinput:number = (_input - _minsrc) / (_maxsrc - _minsrc);
		if (_percentinput < 0) _percentinput = 0;
		if (_percentinput > 1) _percentinput = 1;
		var _output:number = _mindst + (_maxdst - _mindst) * _percentinput;
		return _output;
	}
	
	
}